import { render, staticRenderFns } from "./comp_ProductsCarouselForFeaturedCard.vue?vue&type=template&id=5ad41230&scoped=true&"
import script from "./comp_ProductsCarouselForFeaturedCard.vue?vue&type=script&lang=js&"
export * from "./comp_ProductsCarouselForFeaturedCard.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductsCarouselForFeaturedCard.vue?vue&type=style&index=0&id=5ad41230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad41230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
